module.exports = __webpack_public_path__ + "media/images/default/pages/about/1-66b31ef9ff885f329b606462be7fa479.jpg";